import { Link } from '@mui/material'
import { useLocation } from "react-router-dom"
import { Logo } from "../logo"
import './header.scss'

export const Header = () => {
    const location = useLocation()

    const getActiveClass = (lang: string) => {
        return location.search.includes(`lang=${lang}`) ? 'language-active' : ''
    }

    return (
        <header>
            <div>
                <Logo />
            </div>
            <ul className="languages">
                <li>
                    <Link
                        href="?lang=es"
                        className={`language-option ${getActiveClass('es')}`}
                    >
                        ES
                    </Link>
                </li>
                <li>
                    <Link
                        href="?lang=pt"
                        className={`language-option ${getActiveClass('pt')}`}
                    >
                        PT
                    </Link>
                </li>
                <li>
                    <Link
                        href="?lang=en"
                        className={`language-option ${getActiveClass('en')}`}
                    >
                        EN
                    </Link>
                </li>
            </ul>
        </header>
    )
}